import { createSelector } from 'reselect';
import { selectGates } from '../Construction/construction.reducer';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  [constructionSelector, selectGates],
  (construction, gates) => ({
    available: [...construction.available.width],
    info: construction.info.width,
    loaded: construction.parameters_loaded,
    selected: construction.selected.width,
    gates
  })
);
